import styled from 'styled-components'

const NavContainer = styled.nav`
  position: absolute;

  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
  justify-content: center;

  left: 50%;
  bottom: 4vw;

  padding-top: 3vw;
  padding-right: .5em;
  padding-left: .5em;

  transform: translate3d(-50%,0,0);
  box-sizing: border-box;

  max-width: 1100px;
  width: 85%;

  a {
    display: inline-block;
    margin: 2px 0.75vw;
    font-family: Euclid Square;
    font-weight: bold;
    font-size: .75em;
    letter-spacing: 1px;
    color: ${props => props.theme.color === '#000' ? 'rgba(0,0,0,0.6)' : 'rgba(255,255,255,0.6)'};
    text-decoration: none;
    text-transform: uppercase;
    white-space: nowrap;
    position: relative;

    text-shadow: 1px 1px ${props => props.theme.textShadow};

    &.active {
      // font-weight: bold;
      color: ${props => props.theme.color === '#000' ? 'rgba(0,0,0,1)' : 'rgba(255,255,255,1)'};
    }
    &:hover {
      color: ${props => props.theme.hover};
    }

    // &::after {
    //   content: '';
    //   background: black;
    //   position: absolute;
    //   display: block;
    //   height: 0px;
    //   width: auto;
    //   bottom: 2px;
    //   left: 0; right: 0;
    //   z-index: -10;
    //   transition: height 200ms ease;
    // }

    // &.active::after {
    //   height: 8px;
    // }

    // &:hover::after {
    //   height: 2px;
    // }
  }
`;

export default NavContainer;


// WEBPACK FOOTER //
// ./src/components/Nav/index.js